import type { ImageTeaser } from "../../../../aysa_api/services/navigation/v1/teaser.types";

export enum DropType {
  UNSPECIFIED = 0,
  LABEL = 1,
  SHOES = 2,
  PREMIUM = 3,
  LIVESHOW = 4,
}

export interface Drop {
  id: number;
  type: DropType;
  imageTeaser: ImageTeaser;
  // The tracking is optional, in case it is `null` no tracking should be performed.
  promotionTracking?: Drop_PromotionTracking;
}

export interface Drop_PromotionTracking {
  id: string;
  name: string;
}
